export const TENANT_VILMERS = 'vilmers'
export const TENANT_KAUNO_BALDAI = 'kauno_baldai'
